<template>
  <div>
    <b-row class="my-5 mx-0" align-h="center">
      <b-col cols="11">
        <b-row class="mb-3">
          <b-col>
            <router-link to="/app/aprobaciones" class="mb-1 mb-lg-0">
              <font-awesome-icon :icon="['far', 'arrow-left']" fixed-width />
              Aprobaciones
            </router-link>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h2 class="mb-0">Administración de módulos y permisos</h2>
            <p class="text-muted px-2 mb-0">
              Gestión de los módulos y permisos de aprobación (crear, editar, eliminar)
            </p>
          </b-col>
        </b-row>

        <!-- module list -->
        <div id="module-list">
          <b-row  class="mt-4">
            <b-col>
              <h5>Módulos</h5>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="8" lg="10" align-self="center">
              <b-form-group class="mb-0">
                <b-input-group>
                  <b-input
                    v-model="modulesSearchTerm"
                    autofocus
                    placeholder="Buscar por nombre"
                  />
                  <b-input-group-append class="ml-3">
                    <b-button variant="outline-secondary" @click="modulesSearchTerm = ''">
                      <font-awesome-icon :icon="['far', 'undo-alt']" fixed-width />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="4" lg="2" class="text-right" align-self="center">
              <b-button variant="primary" class="mb-1 mb-lg-0 ml-3" @click="openCreateModule">
                <font-awesome-icon :icon="['fas', 'plus']" fixed-width />
                <span class="pl-1">Módulo</span>
              </b-button>
            </b-col>
          </b-row>

          <b-table
            :items="modules"
            :fields="moduleFields"
            select-mode="single"
            class="fs-15 mt-2"
            show-empty
            caption-top
            hover
            responsive
            selectable
            sticky-header="150"
            @row-selected="onRowModuleSelected"
          >
            <template #empty>
              <div v-if="loading" class="text-center text-secondary">
                <b-spinner small type="grow"></b-spinner>
                <span class="pl-2 fs-18">Consultando módulos...</span>
              </div>
              <div v-else class="text-center font-italic">
                <span v-if="modulesSearchTerm">No hay coincidencias</span>
                <span v-else>No hay módulos para mostrar</span>
              </div>
            </template>

            <template #cell(selected)="{ rowSelected }">
              <template v-if="rowSelected">
                <font-awesome-icon
                  :icon="['fas', 'check-square']"
                  size="lg"
                  fixed-width
                  class="text-success clickable"
                />
              </template>
              <template v-else>
                <font-awesome-icon
                  :icon="['far', 'square']"
                  size="lg"
                  fixed-width
                  class="clickable"
                />
              </template>
            </template>

            <template #cell(code)="data">
              <span>{{ data.value }}</span>
            </template>

            <template #cell(name)="data">
              <span>{{ data.value }}</span>
            </template>

            <template #cell(actions)="data">
              <b-link class="fs-15 text-dark" @click="openEditModule(data.item)">
                <font-awesome-icon :icon="['far', 'edit']" fixed-width />
                <span class="pl-1">Editar</span>
              </b-link>
            </template>
          </b-table>
        </div>

        <!-- action list -->
        <div v-if="moduleAlreadySelected" id="module-actions">
          <b-row  class="mt-4">
            <b-col>
              <h5>Permisos del módulo <span class="font-weight-bold">{{ selectedModule.name }}</span></h5>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="8" lg="10" align-self="center">
              <b-form-group class="mb-0">
                <b-input-group>
                  <b-input
                    v-model="actionsSearchTerm"
                    autofocus
                    placeholder="Buscar por nombre o descripción"
                  />
                  <b-input-group-append class="ml-3">
                    <b-button variant="outline-secondary" @click="actionsSearchTerm = ''">
                      <font-awesome-icon :icon="['far', 'undo-alt']" fixed-width />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="4" lg="2" class="text-right" align-self="center">
              <b-button variant="primary" class="mb-1 mb-lg-0 ml-3" @click="openCreateAction">
                <font-awesome-icon :icon="['fas', 'plus']" fixed-width />
                <span class="pl-1">Permiso</span>
              </b-button>
            </b-col>
          </b-row>

          <b-table
            :items="actions"
            :fields="actionFields"
            select-mode="single"
            class="fs-15 mt-2"
            show-empty
            caption-top
            hover
            responsive
            selectable
            sticky-header="150"
            @row-selected="onRowActionSelected"
          >
            <template #empty>
              <div v-if="loading" class="text-center text-secondary">
                <b-spinner small type="grow"></b-spinner>
                <span class="pl-2 fs-18">Consultando permisos...</span>
              </div>
              <div v-else class="text-center font-italic">
                <span v-if="actionsSearchTerm">No hay coincidencias</span>
                <span v-else>No hay permisos para el módulo seleccionado</span>
              </div>
            </template>

            <template #cell(selected)="{ rowSelected }">
              <template v-if="rowSelected">
                <font-awesome-icon
                  :icon="['fas', 'check-square']"
                  size="lg"
                  fixed-width
                  class="text-success clickable"
                />
              </template>
              <template v-else>
                <font-awesome-icon
                  :icon="['far', 'square']"
                  size="lg"
                  fixed-width
                  class="clickable"
                />
              </template>
            </template>

            <template #cell(code)="data">
              <span>{{ data.value }}</span>
            </template>

            <template #cell(name)="data">
              <span>{{ data.value }}</span>
            </template>

            <template #cell(description)="data">
              <span>{{ data.value }}</span>
            </template>

            <template #cell(actions)="data">
              <b-link class="fs-15 text-dark" @click="openEditAction(data.item)">
                <font-awesome-icon :icon="['far', 'edit']" fixed-width />
                <span class="pl-1">Editar</span>
              </b-link>
            </template>
          </b-table>
        </div>

        <!-- action group list -->
        <div v-if="actionAlreadySelected" id="action-groups">
          <b-row  class="mt-4">
            <b-col>
              <h5>Grupos de Autorización para <span class="font-weight-bold">{{ selectedAction.name }}</span></h5>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="8" lg="10" align-self="center">
              <b-form-group class="mb-0">
                <b-input-group>
                  <b-input
                    v-model="groupSearchTerm"
                    autofocus
                    placeholder="Buscar por nombre"
                  />
                  <b-input-group-append class="ml-3">
                    <b-button variant="outline-secondary" @click="groupSearchTerm = ''">
                      <font-awesome-icon :icon="['far', 'undo-alt']" fixed-width />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="4" lg="2" class="text-right" align-self="center">
              <b-button variant="primary" class="mb-1 mb-lg-0 ml-3" @click="openCreateGroup">
                <font-awesome-icon :icon="['fas', 'plus']" fixed-width />
                <span class="pl-1">Grupo</span>
              </b-button>
            </b-col>
          </b-row>

          <b-table
            :items="groups"
            :fields="groupFields"
            class="fs-15 mt-2"
            show-empty
            caption-top
            hover
            responsive
          >
            <template #empty>
              <div v-if="loading" class="text-center text-secondary">
                <b-spinner small type="grow"></b-spinner>
                <span class="pl-2 fs-18">Consultando grupos de autorización...</span>
              </div>
              <div v-else class="text-center font-italic">
                <span v-if="groupSearchTerm">No hay coincidencias</span>
                <span v-else>No hay grupos para el permiso seleccionado</span>
              </div>
            </template>

            <template #cell(code)="data">
              <span>{{ data.value }}</span>
            </template>

            <template #cell(name)="data">
              <span>{{ data.value }}</span>
            </template>

            <template #cell(is_active)="data">
              <b-badge v-if="data.value" variant="success" class="fs-12">Activo</b-badge>
              <b-badge v-else variant="danger" class="fs-12">Inactivo</b-badge>
            </template>

            <template #cell(actions)="data">
              <b-link class="fs-15 text-dark" @click="openEditGroup(data.item)">
                <font-awesome-icon :icon="['far', 'edit']" fixed-width />
                <span class="pl-1">Editar</span>
              </b-link>
            </template>
          </b-table>
        </div>
      </b-col>
    </b-row>

    <!-- module Modal -->
    <Modal
      v-if="moduleModalShow"
      contentWidth="800px"
      :required=true
      @close="onCloseModuleModal"
    >
      <template #header>
        <p class="fs-20 font-weight-bold ml-1 mb-0" style="line-height: 0.675rem; color: #163D7D;">
          {{ moduleModalAction === 'edit' ? 'Editar módulo' : 'Crear módulo' }}
        </p>
      </template>
      <template #body>
        <b-row>
          <b-col>
            <!-- module name -->
            <div class="mb-2">
              <p class="mb-0 fs-18 mb-1">Nombre</p>
              <b-input
                v-model="moduleForm.name"
                type="text"
                trim
                class="fs-18"
                placeholder="Nombre del módulo de la aplicación"
                style="width: 100%;"
              />
            </div>
            <!-- feedback -->
            <div v-if="moduleFeedBack || processingModule" class="mt-3 mb-2 text-center">
              <p v-if="processingModule" class="text-info">
                <b-spinner small type="grow"></b-spinner>
                <span class="pl-2">Actualizando...</span>
              </p>
              <div v-else class="text-danger d-flex align-items-center justify-content-center">
                <font-awesome-icon :icon="['fas', 'exclamation-triangle']" fixed-width />
                <p class="pl-2 mb-0">{{ moduleFeedBack }}</p>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button
              variant="outline-success"
              class="float-right ml-3"
              :disabled="!moduleForm.name || processingModule"
              @click="moduleModalAction === 'edit' ? updateModule() : createModule()"
            >
              <span v-if="moduleFeedBack">Reintentar</span>
              <span v-else>
                {{ moduleModalAction === 'edit' ? 'Actualizar' : 'Crear' }}
              </span>
            </b-button>
            <b-button variant="outline-danger" class="float-right" @click="onCloseModuleModal()">
              Cancelar
            </b-button>
          </b-col>
        </b-row>
      </template>
      <template #footer>
        <span></span>
      </template>
    </Modal>

    <!-- module action Modal -->
    <Modal
      v-if="actionModalShow"
      contentWidth="800px"
      :required=true
      @close="onCloseActionModal"
    >
      <template #header>
        <p class="fs-20 font-weight-bold ml-1 mb-0" style="line-height: 0.675rem; color: #163D7D;">
          {{ actionModalAction === 'edit' ? 'Editar permiso' : 'Crear permiso' }}
        </p>
      </template>
      <template #body>
        <b-row>
          <b-col>
            <!-- name -->
            <div class="mb-2">
              <p class="mb-0 fs-18 mb-1">Nombre</p>
              <b-input
                v-model="actionForm.name"
                type="text"
                placeholder="Nombre del permiso de la aplicación pra la módulo seleccionado"
                trim
                class="fs-18"
                style="width: 100%;"
              />
            </div>
            <!-- Description -->
            <div class="mb-2">
              <p class="mb-0 fs-18 mb-1">Descripción</p>
              <b-textarea
                v-model="actionForm.description"
                rows="3"
                class="fs-18"
                style="width: 100%;"
              />
            </div>
            <!-- feedback -->
            <div v-if="actionFeedBack || processingAction" class="mt-3 mb-2 text-center">
              <p v-if="processingAction" class="text-info">
                <b-spinner small type="grow"></b-spinner>
                <span class="pl-2">Actualizando...</span>
              </p>
              <div v-else class="text-danger d-flex align-items-center justify-content-center">
                <font-awesome-icon :icon="['fas', 'exclamation-triangle']" fixed-width />
                <p class="pl-2 mb-0">{{ actionFeedBack }}</p>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button
              variant="outline-success"
              class="float-right ml-3"
              :disabled="!actionForm.name || !actionForm.description || processingAction"
              @click="actionModalAction === 'edit' ? updateAction() : createAction()"
            >
              <span v-if="actionFeedBack">Reintentar</span>
              <span v-else>
                {{ actionModalAction === 'edit' ? 'Actualizar' : 'Crear' }}
              </span>
            </b-button>
            <b-button variant="outline-danger" class="float-right" @click="onCloseActionModal()">
              Cancelar
            </b-button>
          </b-col>
        </b-row>
      </template>
      <template #footer>
        <span></span>
      </template>
    </Modal>

    <!-- Group Modal -->
    <Modal
      v-if="groupModalShow"
      contentWidth="800px"
      :required=true
      @close="onCloseGroupModal"
    >
      <template #header>
        <p class="fs-20 font-weight-bold ml-1 mb-0" style="line-height: 0.675rem; color: #163D7D;">
          {{ groupModalAction === 'edit' ? 'Editar grupo' : 'Crear grupo' }}
        </p>
      </template>
      <template #body>
        <b-row>
          <b-col>
            <!-- name -->
            <div class="mb-2">
              <p class="mb-0 fs-18 mb-1">Nombre</p>
              <b-input
                v-model="groupForm.name"
                type="text"
                placeholder="Nombre del permiso de la aplicación pra la módulo seleccionado"
                trim
                class="fs-18"
                style="width: 100%;"
              />
            </div>
            <!-- is_active -->
            <div class="mb-2">
              <p class="mb-0 fs-18">Estado</p>
              <b-form-group label="" class="ml-4">
                <b-form-radio-group
                  id="radio-group-2"
                  v-model="groupForm.is_active"
                  name="active-radio-group"
                >
                <b-form-radio value="false">Inactivo</b-form-radio>
                <b-form-radio value="true">Activo</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>

            <!-- feedback -->
            <div v-if="groupFeedBack || processingGroup" class="mt-3 mb-2 text-center">
              <p v-if="processingGroup" class="text-info">
                <b-spinner small type="grow"></b-spinner>
                <span class="pl-2">Actualizando...</span>
              </p>
              <div v-else class="text-danger d-flex align-items-center justify-content-center">
                <font-awesome-icon :icon="['fas', 'exclamation-triangle']" fixed-width />
                <p class="pl-2 mb-0">{{ groupFeedBack }}</p>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button
              variant="outline-success"
              class="float-right ml-3"
              :disabled="!groupForm.name || processingGroup"
              @click="groupModalAction === 'edit' ? updateGroup() : createGroup()"
            >
              <span v-if="groupFeedBack">Reintentar</span>
              <span v-else>
                {{ groupModalAction === 'edit' ? 'Actualizar' : 'Crear' }}
              </span>
            </b-button>
            <b-button variant="outline-danger" class="float-right" @click="onCloseGroupModal()">
              Cancelar
            </b-button>
          </b-col>
        </b-row>
      </template>
      <template #footer>
        <span></span>
      </template>
    </Modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import Modal from '../../../components/shared/Modal'

export default {
  name: 'Management',
  components: { Modal },
  data () {
    return {
      loading: false,
      // modules
      appModules: [],
      moduleFields: [
        { key: 'selected', label: '', tdClass: '', thClass: '', thStyle: { width: '100px' }},
        { key: 'code', label: 'Código', tdClass: '', thClass: '' },
        { key: 'code', label: 'Código', tdClass: '', thClass: '' },
        { key: 'name', label: 'Nombre', tdClass: 'align-middle', thClass: '' },
        { key: 'actions', label: '', tdClass: 'align-middle text-center', thClass: 'text-center', thStyle: { width: '100px' } }
      ],
      moduleAlreadySelected: false,
      selectedModule: {},
      modulesSearchTerm: '',
      moduleForm: {
        id: null,
        name: null
      },
      moduleFeedBack: null,
      processingModule: false,
      // actions
      moduleActions: [],
      actionFields: [
        { key: 'selected', label: '', tdClass: '', thClass: '', thStyle: { width: '100px' }},
        { key: 'code', label: 'Código', tdClass: '', thClass: '', thStyle: { width: '300px' }},
        { key: 'name', label: 'Nombre', tdClass: 'align-middle', thClass: '', thStyle: { width: '300px' } },
        { key: 'description', label: 'Descripción', tdClass: 'align-middle', thClass: '' },
        { key: 'actions', label: '', tdClass: 'align-middle text-center', thClass: 'text-center', thStyle: { width: '100px' } }
      ],
      actionAlreadySelected: false,
      selectedAction: {},
      actionsSearchTerm: '',
      actionForm: {
        id: null,
        approval_module_id: null,
        name: null,
        description: null
      },
      actionFeedBack: null,
      processingAction: false,
      // alerts
      alertShow: false,
      alertVariant: null,
      alertMessage: '',
      // groups
      actionGroups: [],
      groupSearchTerm: '',
      groupFields: [
        { key: 'code', label: 'Código', tdClass: '', thClass: '', thStyle: { width: '300px' }},
        { key: 'name', label: 'Nombre', tdClass: 'align-middle', thClass: '', thStyle: { width: '300px' } },
        { key: 'is_active', label: 'Estado', tdClass: 'text-left', thClass: 'text-left' },
        { key: 'actions', label: '', tdClass: 'align-middle text-center', thClass: 'text-center', thStyle: { width: '100px' } }
      ],
      groupForm: {
        id: null,
        name: null,
        is_active: true
      },
      groupFeedBack: null,
      processingGroup: false,
      // modals
      moduleModalAction: 'edit',
      moduleModalShow: false,
      actionModalAction: 'edit',
      actionModalShow: false,
      groupModalAction: 'edit',
      groupModalShow: false,
    }
  },
  mounted () {
    if (!this.isDev) {
      this.$router.replace('/app/aprobaciones')
      return
    }

    this.fetchModules()
  },
  computed: {
    ...mapGetters(['isDev']),
    modules () {
      const term = this.modulesSearchTerm?.toLowerCase()

      const results = term
        ? this.appModules.filter(m =>
            m.name.toLowerCase().includes(term)
          )
        : this.appModules

      return this.sortOptions(results)
    },
    actions () {
      const term = this.actionsSearchTerm?.toLowerCase()

      const results = term
        ? this.moduleActions.filter(m =>
            m.name.toLowerCase().includes(term) ||
            m.description.toLowerCase().includes(term)
          )
        : this.moduleActions

      return this.sortOptions(results)
    },
    groups () {
      const term = this.groupSearchTerm?.toLowerCase()

      const results = term
        ? this.actionGroups.filter(m =>
            m.name.toLowerCase().includes(term)
          )
        : this.actionGroups

      return this.sortOptions(results)
    }
  },
  methods: {
    // modules
    fetchModules () {
      this.loading = true
      this.$http.get('/api/approval_modules')
        .then(response => {
          // console.log(response.data)
          this.appModules = response.data
        })
        .catch(error => {
          // console.log(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onRowModuleSelected(selectedModules) {
      const appModule = selectedModules[0] || {}
      if (!appModule?.id) {
        this.moduleAlreadySelected = false
        return
      }
      if (appModule.id === this.selectedModule.id) {
        this.moduleAlreadySelected = true
        return
      }

      this.moduleAlreadySelected = true
      this.selectedModule = appModule
      this.fetchActions()
    },
    openEditModule (selectedModuleToEdit) {
      this.moduleModalAction = 'edit'
      this.moduleForm.id = selectedModuleToEdit.id
      this.moduleForm.name = selectedModuleToEdit.name
      this.moduleModalShow = true
    },
    onCloseModuleModal () {
      this.moduleForm.id = null
      this.moduleForm.name = null
      this.moduleModalShow = false
    },
    updateModule () {
      if (this.processingModule) return
      this.processingModule = true
      this.$http.patch(`/api/approval_modules/${this.moduleForm.id}`, {
          approval_module: {
            name: this.moduleForm.name
          }
        })
        .then(response => {
          // console.log(response)
          const index = this.appModules.findIndex(m => m.id === response.data.id)
          if (index > -1) {
            this.appModules[index].name = this.moduleForm.name
          }
          this.moduleFeedBack = null
          this.processingModule = false
          this.onCloseModuleModal()
        })
        .catch(error => {
          // console.log(error)
          this.moduleFeedBack = 'Hubo un error al actualizar el módulo, intente nuevamente'
          this.processingModule = false
        })
    },
    openCreateModule () {
      this.moduleModalAction = 'create'
      this.moduleForm.id = null
      this.moduleForm.name = null
      this.moduleModalShow = true
    },
    createModule () {
      if (this.processingModule) return
      this.processingModule = true
      this.$http.post('/api/approval_modules', {
          approval_module: {
            name: this.moduleForm.name
          }
        })
        .then(response => {
          // console.log(response)
          this.appModules.unshift(response.data)
          this.moduleFeedBack = null
          this.processingModule = false
          this.onCloseModuleModal()
        })
        .catch(error => {
          // console.log(error.response.data)
          const srvError = error.response?.data?.error || ''
          if (srvError.includes('La validación falló: Code ya está en uso')) {
            this.moduleFeedBack = 'El módulo ya existe'
          } else {
            this.moduleFeedBack = 'Hubo un error al crear el módulo, intente nuevamente'
          }

          this.processingModule = false
        })
    },
    // actions
    onRowActionSelected(selectedActions) {
      const action = selectedActions[0] || {}
      if (!action?.id) {
        this.actionAlreadySelected = false
        return
      }
      if (action.id === this.selectedAction.id) {
        this.actionAlreadySelected = true
        return
      }

      this.actionAlreadySelected = true
      this.selectedAction = action

      this.fetchGroups()
    },
    fetchActions () {
      if (!this.selectedModule.id) return
      this.loading = true
      this.$http.get(`/api/approval_modules/${this.selectedModule.id}/approval_actions`)
        .then(response => {
          // console.log(response.data)
          this.moduleActions = response.data
        })
        .catch(error => {
          // console.log(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    openEditAction (selectedActionToEdit) {
      this.actionForm.id = selectedActionToEdit.id
      this.actionForm.approval_module_id = selectedActionToEdit.approval_module_id
      this.actionForm.name = selectedActionToEdit.name
      this.actionForm.description = selectedActionToEdit.description
      this.actionModalShow = true
    },
    onCloseActionModal () {
      this.actionForm.id = null
      this.actionForm.name = null
      this.actionForm.description = null
      this.actionModalShow = false
    },
    updateAction () {
      if (this.processingAction) return
      this.processingAction = true
      this.$http.patch(`/api/approval_modules/${this.actionForm.approval_module_id}/approval_actions/${this.actionForm.id}`, {
          approval_action: {
            name: this.actionForm.name,
            description: this.actionForm.description
          }
        })
        .then(response => {
          // console.log(response)
          const index = this.moduleActions.findIndex(m => m.id === response.data.id)
          if (index > -1) {
            this.moduleActions[index].name = this.actionForm.name
            this.moduleActions[index].description = this.actionForm.description
          }
          this.actionFeedBack = null
          this.processingAction = false
          this.onCloseActionModal()
        })
        .catch(error => {
          // console.log(error)
          this.actionFeedBack = 'Hubo un error al actualizar el permiso, intente nuevamente'
          this.processingAction = false
        })
    },
    openCreateAction () {
      this.actionModalAction = 'create'
      this.actionForm.id = null
      this.actionForm.approval_module_id = this.selectedModule.id
      this.actionForm.name = null
      this.actionForm.description = null
      this.actionModalShow = true
    },
    createAction () {
      if (this.processingAction) return
      this.processingAction = true
      this.$http.post(`/api/approval_modules/${this.selectedModule.id}/approval_actions`, {
          approval_action: {
            name: this.actionForm.name,
            description: this.actionForm.description
          }
        })
        .then(response => {
          // console.log(response)
          this.moduleActions.unshift(response.data)
          this.actionFeedBack = null
          this.processingAction = false
          this.onCloseActionModal()
        })
        .catch(error => {
          // console.log(error)
          const srvError = error.response?.data?.error || ''
          if (srvError.includes('La validación falló: Code ya está en uso')) {
            this.actionFeedBack = 'El permiso ya existe'
          } else {
            this.actionFeedBack = 'Hubo un error al crear el permiso, intente nuevamente'
          }
          this.processingAction = false
        })
    },
    // groups
    fetchGroups () {
      if (!this.selectedModule.id) return
      this.loading = true
      this.$http.get(`/api/approval_modules/${this.selectedModuleId}/approval_actions/${this.selectedAction.id}/approval_groups`)
        .then(response => {
          // console.log(response.data)
          this.actionGroups = response.data
        })
        .catch(error => {
          // console.log(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    openCreateGroup () {
      this.groupModalAction = 'create'
      this.groupForm.id = null
      this.actionForm.name = null
      this.actionForm.is_active = true
      this.groupModalShow = true
    },
    openEditGroup (group) {
      this.groupForm.id = group.id
      this.groupForm.name = group.name
      this.groupForm.is_active = group.is_active
      this.groupModalShow = true
    },
    updateGroup (_group, _isActive) {
      if (this.processingGroup) return
      this.processingGroup = true
      this.$http.patch(`/api/approval_modules/${this.selectedModule.id}/approval_actions/${this.selectedAction.id}/approval_groups/${this.groupForm.id}`, {
          approval_group: {
            name: this.groupForm.name,
            is_active: this.groupForm.is_active
          }
        })
        .then(response => {
          // console.log(response)
          const index = this.actionGroups.findIndex(m => m.id === response.data.id)
          if (index > -1) {
            this.actionGroups[index].name = response.data.name
            this.actionGroups[index].is_active = response.data.is_active
          }
          this.groupFeedBack = null
          this.processingGroup = false
          this.onCloseGroupModal()
        })
        .catch(error => {
          // console.log(error)
          this.groupFeedBack = 'Hubo un error al actualizar el grupo, intente nuevamente'
          this.processingGroup = false
        })
    },
    onCloseGroupModal () {
      this.groupForm.id = null
      this.groupForm.name = null
      this.groupForm.is_active = false
      this.groupModalShow = false
    },
    createGroup () {
      this.$http.post(`/api/approval_modules/${this.selectedModule.id}/approval_actions/${this.selectedAction.id}/approval_groups`, {
          approval_group: {
            name: this.groupForm.name,
            is_active: this.groupForm.is_active
          }
        })
        .then(response => {
          // console.log(response)
          this.actionGroups.unshift(response.data)
          this.groupFeedBack = null
          this.processingGroup = false
          this.onCloseGroupModal()
        })
        .catch(error => {
          // console.log(error)
          this.groupFeedBack = 'Hubo un error al crear el grupo, intente nuevamente'
          this.processingGroup = false
        })
    },
    // others
    sortOptions (options) {
      return options.sort((a, b) => a.name.localeCompare(b.name, 'es'))
    }
  }
}
</script>